import React, { useEffect, useRef, useState } from "react"
import { Button, Textarea, Span } from "../../../StyleComponents/styles"

const ListAddInput = ({ valueInput, setValueInput }) => {
  let [copyButtonName, setCopied] = useState("Copy")
  let listE = useRef("")

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("Emoji", valueInput)
    }
  }, [valueInput])

  function copyList() {
    let list = listE.current
    list.select()
    let copied = document.execCommand("copy")
    if (copied) {
      setCopied("Copied")
      setTimeout(function () {
        setCopied("Copy List")
      }, 1500)
    }
  }

  return (
    <div>
      <p className="mb-1">
        <Span>Emoji text area</Span>
      </p>
      <Textarea
        className="mb-3"
        aria-label="emoji-area"
        value={valueInput}
        ref={listE}
        onChange={e => setValueInput(e.target.value)}
      ></Textarea>
      <Button
        className="mb-2"
        borderColor="#1da1f2"
        color="#1da1f2"
        hoverColor="white"
        hoverBorderColor="#1da1f2"
        hoverBackgroundColor="#1da1f2"
        onClick={copyList}
      >
        {copyButtonName}
      </Button>

      <Button
        className="mb-2"
        borderColor="#ea4336"
        color="#ea4336"
        hoverBorderColor="#ea4336"
        hoverBackgroundColor="#ea4336"
        hoverColor="white"
        onClick={() => {
          setValueInput("")
        }}
      >
        Clear
      </Button>
    </div>
  )
}

export default ListAddInput
